import { isObjectType, isString } from 'remeda';

import ApiErrorCodes from '@@api/constants/errorCodes';

export const isPlacementTenantError = (body: unknown) =>
    isObjectType(body) &&
    'status' in body &&
    'message' in body &&
    body.status === ApiErrorCodes.BAD_REQUEST &&
    isString(body.message) &&
    body.message.includes('are not assigned to tenant');

export const COPY_SECTION_ERROR_MESSAGES = {
    'At least one source section category is missing in the target sitemap.':
        'SECTION_CATEGORY_IS_MISSING_IN_THE_TARGET_SITEMAP',
    "Section can't be copied to its referenced Category Page.":
        'SECTION_CANNOT_BE_COPIED_TO_ITS_REFERENCED_PAGE',
    'Default Sections cannot be copied.': 'DEFAULT_SECTION_CANNOT_BE_COPIED',
};

export const isPlacementCopySectionError = (body: unknown) => {
    const errorMessages = Object.keys(COPY_SECTION_ERROR_MESSAGES);

    return (
        isObjectType(body) &&
        'status' in body &&
        'message' in body &&
        body.status === ApiErrorCodes.BAD_REQUEST &&
        isString(body.message) &&
        errorMessages.includes(body.message)
    );
};
